import { call, put, takeLatest } from "redux-saga/effects"

import { GET_LIST_QUESTIONS_WATCHER } from "./constants"

import {
  getListQuestionsSuccess,
  getListQuestionsFailed,
  getListOnlyQuestionsSuccess,
  getListOnlyQuestionsFailed,
} from "./actions"
import {
  getListQuestionsApi,
  getQualitativeAnswersApi,
} from "../../../utils/routes/routes-report"

export function* getListQuestionsSaga(params) {
  try {
    const { measureGeneral } = params.payload
    
    // Use measureGeneral from payload instead of calling getMeasureInfoApi
    if (measureGeneral.segments.length === 1) {
      params.payload.id_segment = measureGeneral.segments[0].id_segment
      params.payload.id_survey = measureGeneral.id_survey
    } else {
      if (params.payload.id_segment) {
        params.payload.id_survey = measureGeneral.id_survey
      }
    }
    
    params.payload.measure_type = measureGeneral.id_measure_type || null
    
    const { data: qualitative } = yield call(
      getListQuestionsApi,
      params.payload
    )
    yield put(getListOnlyQuestionsSuccess(qualitative))

    const filterQualitative = qualitative.filter((item) => {
      return item.enabled
    })

    params.payload.question =
      (filterQualitative[0] && filterQualitative[0].id_question) || null

    if(!params.payload.question) {
      yield put(getListQuestionsSuccess([]))
    } else {
      yield put(getListQuestionsSuccess(filterQualitative))
    }

    
  } catch (e) {
    console.log(e)
    yield put(getListOnlyQuestionsFailed())
    yield put(getListQuestionsFailed())
  }
}

// Individual exports for testing
export default function* widgetQualitativeQuestionSaga() {
  yield takeLatest(GET_LIST_QUESTIONS_WATCHER, getListQuestionsSaga)
}
